import { supabase } from '../lib/supabase'
import type { Expense } from '../types/index'

function rowToExpense(r: Record<string, unknown>): Expense {
  return {
    id:          r.id as string,
    description: r.description as string,
    category:    (r.category as Expense['category']) || 'Misc',
    amount:      (r.amount as number) || 0,
    date:        r.date as string,
    vendor:      (r.vendor as string) || '',
    receipt:     r.receipt as string | undefined,
    approvedBy:  r.approved_by as string | undefined,
  }
}

export async function getExpenses(): Promise<Expense[]> {
  const { data, error } = await supabase.from('expenses').select('*').order('date', { ascending: false })
  if (error) throw error
  return (data ?? []).map(rowToExpense)
}

export async function createExpense(e: Omit<Expense, 'id'>): Promise<Expense> {
  const { data, error } = await supabase.from('expenses').insert({
    description: e.description, category: e.category, amount: e.amount,
    date: e.date, vendor: e.vendor, receipt: e.receipt, approved_by: e.approvedBy,
  }).select().single()
  if (error) throw error
  return rowToExpense(data)
}

export async function updateExpense(id: string, e: Partial<Expense>): Promise<void> {
  const updates: Record<string, unknown> = {}
  if (e.description !== undefined) updates.description = e.description
  if (e.category    !== undefined) updates.category    = e.category
  if (e.amount      !== undefined) updates.amount      = e.amount
  if (e.date        !== undefined) updates.date        = e.date
  if (e.vendor      !== undefined) updates.vendor      = e.vendor
  if (e.receipt     !== undefined) updates.receipt     = e.receipt
  if (e.approvedBy  !== undefined) updates.approved_by = e.approvedBy
  const { error } = await supabase.from('expenses').update(updates).eq('id', id)
  if (error) throw error
}

export async function deleteExpense(id: string): Promise<void> {
  const { error } = await supabase.from('expenses').delete().eq('id', id)
  if (error) throw error
}
